import React, { useState, useEffect } from 'react'
import Icon from 'react-icons-kit'
import { chevronsRight } from 'react-icons-kit/feather'
import ProfileCardList from '../../../../../components/users/profileCardList/Index'
import GhostProfileCard from '../../../../../components/ghostLoader/user/profileCardListLoader/Index'

const Index = () => {
    const [isLoading, setLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 2000)
    })

    return (
        <div>
            <div className="title-container pl-1">
                <div className="d-flex">
                    <div>
                        <Icon icon={chevronsRight} size={25} />
                    </div>
                    <div><h5 className="mb-3">Block Profiles</h5></div>
                </div>
            </div>
            {isLoading ?
                <GhostProfileCard /> :
                <ProfileCardList />
            }
        </div>
    );
}

export default Index;